(function hydrateSession() {
	const cached = localStorage.getItem('lastActiveAccount');
	if (cached && !sessionStorage.getItem('activeAccount')) {
		sessionStorage.setItem('activeAccount', cached);
	}
})();

export function setActiveAccount(accountObj) {
	const value = JSON.stringify(accountObj);
	sessionStorage.setItem('activeAccount', value);
	localStorage.setItem('lastActiveAccount', value);
}
